import React, {useEffect, useState} from "react";
import {Box} from "@chakra-ui/react";
import FormPasswordComponent from "../Password/FormPasswordComponent";
import {hasMinimumLength, hasNumbers, hasSymbols, hasUpperCase} from "../Password/PasswordValidators";

/**
 * Change Password Component
 * Includes optional original password field and new + confirm password fields
 * Props:
 *  onPasswordChange,
 *  onOriginalPasswordChange,
 *  onIsInvalidChange,
 *  isOriginalRequired,
 *  isVisible
 */
export default function ChangePasswordComponent(props) {

  const {
    onPasswordChange,
    onOriginalPasswordChange,
    onIsInvalidChange,
    isOriginalRequired,
    isVisible
  } = props;
  const [password, setPassword] = useState("");
  const [originalPassword, setOriginalPassword] = useState("");
  const [originalPasswordInvalid, setOriginalPasswordInvalid] = useState(false);
  const [passwordInvalid, setPasswordInvalid] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordInvalid, setConfirmPasswordInvalid] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);

  useEffect(() => {
    if (onOriginalPasswordChange) {
      onOriginalPasswordChange(originalPassword);
    }
  }, [originalPassword]);

  useEffect(() => {
    if (password !== confirmPassword) {
      setValidationErrors(["Passwords do not match."]);
    } else {
      setValidationErrors([]);
    }
    if (onPasswordChange) {
      onPasswordChange(password);
    }
  }, [password, confirmPassword]);

  useEffect(() => {
    if (onIsInvalidChange) {
      onIsInvalidChange(originalPasswordInvalid || passwordInvalid || confirmPasswordInvalid);
    }
  }, [originalPasswordInvalid, passwordInvalid, confirmPasswordInvalid]);

  const originalPasswordValidator = (value) =>
    value !== "" ? null : "Password cannot be empty";

  if (!isVisible) {
    return null;
  }

  return (
    <Box overflow="visible" maxHeight="100vh" width="100%">
      {isOriginalRequired && (
        <FormPasswordComponent
          id="originalPassword"
          label="Original Password"
          isRequired
          onChange={setOriginalPassword}
          onIsInvalidChange={setOriginalPasswordInvalid}
          validators={[originalPasswordValidator]}
        />
      )}
      <FormPasswordComponent
        id="password"
        label="Password"
        isRequired
        onChange={setPassword}
        onIsInvalidChange={setPasswordInvalid}
        validators={[
          hasMinimumLength,
          hasUpperCase,
          hasNumbers,
          hasSymbols,
        ]}
        validationErrors={validationErrors}
      />
      <FormPasswordComponent
        id="confirmPassword"
        label="Confirm Password"
        isRequired
        onChange={setConfirmPassword}
        onIsInvalidChange={setConfirmPasswordInvalid}
        validators={[
          hasMinimumLength,
          hasUpperCase,
          hasNumbers,
          hasSymbols,
        ]}
        validationErrors={validationErrors}
      />
    </Box>
  );
}
